import Carousel from "@brainhubeu/react-carousel";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import * as React from "react";
import { useContext, useState } from "react";
import { Context } from "../../../../Context/context";
import { baseStyle } from "../../../../theme";
import { ShapeSetting } from "../../../../TypesAndConstants/types";
import { ImageUpload } from "./ImageUpload";
import { getShapeImages, shapes } from "./ShapeItems";
import { ArtThreadGallerySelect } from "./ArtThreadGallerySelect";
import { THREE_INST } from "../../../SketchUtilities/Three/threeSingleton";
import { Button, ButtonGroup } from "@mui/material";
import ShapeGallery from "./ShapeGallery"

interface Props {
  isMobile?: boolean;
}

const ShapeContainer = (props: Props) => {
  const three = THREE_INST.getInst();
  const { isMobile } = props;
  const {
    state: {
      imageModalOpen,
      shapeSettings,
      userSessionData,
    },
    dispatch,
  } = useContext(Context);
  const [galleryOpen, setGalleryOpen] = useState<boolean>(false);
  const baseTheme = baseStyle({ containerWidth: "50%", menuWidth: "30%" });

  React.useEffect(() => {
    three.obj.isImageMenuOpen = imageModalOpen;
  }, [imageModalOpen]);




  const secondaryUI = {
    padding: "10px",
    fontFamily: "'amatic', cursive",
  } as React.CSSProperties;

  const loadButton = () => {
    return (
      <Button
        variant="contained"
        onClick={() => {
          if (!imageModalOpen) {
            dispatch({
              type: "close_imagemodal",
              value: true,
            });
          }
        }}
        color="primary"
      >
        <CreateNewFolderIcon />
        <p>Load An Image!</p>
        <ImageUpload />
      </Button>
    );
  };


  return (
    <div style={{ display: "flex", zIndex: 1001 }} id={"shapes"}>
      <div className={isMobile ? baseTheme.mobileMenu : ""}>
        <ShapeGallery/>
        <div id={"shapeButton"} style={secondaryUI}>
          {userSessionData.session &&
          userSessionData.session.response_code !== 404 ? (
            <>
              <Button
                variant="contained"
                onClick={() => {
                  setGalleryOpen(true);
                }}
                color="primary"
              >
                Get Images from your Gallery
              </Button>
              {loadButton()}
            </>
          ) : (
            loadButton()
          )}

          {ArtThreadGallerySelect({
            open: galleryOpen,
            close: () => {
              setGalleryOpen(false);
            },
          })}

          {/* <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              onClick={() => {
                if (!imageModalOpen) {
                  dispatch({
                    type: "close_imagemodal",
                    value: true,
                  });
                }
              }}
              style={{ display: "inline-flex", cursor: "pointer" }}
            >
              <CreateNewFolderIcon />
              <p style={{ marginTop: "0px" }}>Load An Image!</p>
              <ImageUpload />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ShapeContainer;
